module.exports = __webpack_public_path__ + "static/media/chrome_logo.8bdda5bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/browser/chrome_logo.svg
// module id = 1598
// module chunks = 0